import Styles from './PostTypeSelect.module.scss'
import { MobileWizard } from 'components/Wizards/MobileWizards/Layout'
import { multiStep } from 'components/Wizards/MobileWizards/MultiStepMobileWizard/multiStep'
import { StepProps } from 'components/Wizards/MobileWizards/MultiStepMobileWizard/Types'
import { MediaType } from 'components/Wizards/schemas/shared/mediaType'
import { ContentCard } from 'screens/blaze/Home/MobileHome/ContentCard/ContentCard'
import { useFormikContext } from 'formik'

interface PostTypeSelectProps extends StepProps {
  setMediaType: (mediaType: MediaType) => void
}

export const PostTypeSelect = multiStep<PostTypeSelectProps>(({ schema, submit, setMediaType }) => {
  const { meta } = schema.describe()
  const formik = useFormikContext<any>()

  const handleCardPress = (postType: MediaType) => {
    setMediaType(postType)
    formik.setFieldValue('include_images', postType === MediaType.DocumentWithImages)
    submit()
  }

  return (
    <MobileWizard.Content>
      <MobileWizard.Section>
        <MobileWizard.Title>{meta.title}</MobileWizard.Title>
      </MobileWizard.Section>
      <MobileWizard.Section gap={10}>
        <ContentCard
          className={Styles.customCard}
          title="Just Captions"
          description="with a simple photo or video"
          imgSrc="https://res.cloudinary.com/almanac/image/upload/v1741201586/blaze_assets/mobile_home_and_create_new/L3/just_captions_post.png"
          imgScale={0.48}
          textWidth="50%"
          onPress={() => handleCardPress(MediaType.Document)}
        />
        <ContentCard
          className={Styles.customCard}
          title="Simple Images"
          description="with a single photo or video"
          imgSrc="https://res.cloudinary.com/almanac/image/upload/v1741201586/blaze_assets/mobile_home_and_create_new/L3/linkedin-post_g7cytj.png"
          imgScale={0.65}
          imgBottom={-50}
          textWidth="45%"
          onPress={() => handleCardPress(MediaType.DocumentWithImages)}
        />
        {/* This block for "Visually Dynamic" post type will be reinstated later.
            For now, we only want images and captions for this flow.
        <ContentCard
          className={Styles.customCard}
          title="Visually Dynamic"
          description="with a custom designed template"
          imgSrc="https://res.cloudinary.com/almanac/image/upload/v1741201586/blaze_assets/mobile_home_and_create_new/L3/Social_Thumbs_10_gjz7bc.png"
          imgScale={0.5}
          imgBottom={-10}
          textWidth="50%"
          onPress={() => handleCardPress(MediaType.Design)}
        />
        */}
      </MobileWizard.Section>
    </MobileWizard.Content>
  )
})
